const ElectronicDocument = () =>
  import("@/views/electtronicDocument/ElectronicDocumentList");

export const ElecttronicDocumentRoute = {
  path: "electronicDocuments",
  component: ElectronicDocument,
  meta: {
    requiresAuth: true,
    title: "message.ecommerce",   
    breadcrumb: [
      {
        text: "Consulta de Documentos Electrónicos",
        disabled: false,
        href: "#"
      }
    ],
      scope:["aps_broker","aps_executive"],
  }
};